import type { TradingCompetitionSummary } from '@/components/social/competition/types';
import { formatOgUsdcD6 } from '@/lib/currency/server';

export function formatCompetitionWindow(
  competition: Pick<TradingCompetitionSummary, 'start' | 'end'>,
  locale: string,
  timeZone: string,
): string {
  const formatter = competitionMomentFormatter(locale, timeZone);
  return `${formatter.format(new Date(competition.start))} – ${formatter.format(new Date(competition.end))}`;
}

export function formatCompetitionMoment(iso: string, locale: string, timeZone: string): string {
  return competitionMomentFormatter(locale, timeZone).format(new Date(iso));
}

const momentFormatters: Map<string, Intl.DateTimeFormat> = new Map();

/** Shared images carry their timezone because recipients may be elsewhere. */
export function formatCompetitionEnd(iso: string, locale: string, timeZone: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
    timeZoneName: 'short',
  }).format(new Date(iso));
}

function competitionMomentFormatter(locale: string, timeZone: string): Intl.DateTimeFormat {
  const key = `${locale}|${timeZone}`;
  let formatter = momentFormatters.get(key);
  if (formatter === undefined) {
    formatter = new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone,
    });
    momentFormatters.set(key, formatter);
  }
  return formatter;
}

/** Share-card money label: compact above $10K, whole dollars below (no trailing cents). */
export function formatCompetitionUsdcLabel(d6: bigint): string {
  return formatOgUsdcD6(d6, 'compact').replace(/\.00$/, '');
}
